export class InputDialogResult {
	public constructor(
		public confirmation: boolean,
		public value: string = null
	) {}
}
